/**
 * @generated SignedSource<<7bab978c92f63eed4919ae13ea64a1ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ImageType = "BACKGROUND" | "FEATURED" | "GALLERY" | "ICON" | "LOGO" | "NONE" | "OTHER" | "PRODUCT" | "SHOWCASE" | "VIDEO";
export type OfferEligibilityLevelType = "Account" | "Line" | "NA";
export type ProductBalanceManagementType = "POSTPAID" | "PREPAID";
export type ProductType = "CHARACTERISTIC" | "DEAL" | "FEATURE" | "MARKETING" | "ORIGINAL_RRP";
export type SegmentType = "BUSINESS" | "CONSUMER";
export type StyleType = "PRIMARY" | "PRIMARY_OVERRIDE" | "SECONDARY" | "SECONDARY_OVERRIDE";
export type MobilePlanCardsProductsQuery$variables = {
  categoryId: string;
  channel: string;
  includeCompanions?: boolean | null;
};
export type MobilePlanCardsProductsQuery$data = {
  readonly eligibleProductOffersByCategory: {
    readonly category: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
      readonly plans: ReadonlyArray<{
        readonly contractTerm: {
          readonly name: string | null;
        } | null;
        readonly ctaOverrides: ReadonlyArray<{
          readonly data: string | null;
          readonly label: string | null;
          readonly segment: SegmentType | null;
          readonly sortOrder: number | null;
          readonly style: StyleType | null;
          readonly type: string;
        }> | null;
        readonly dataLayerCategory: string | null;
        readonly entitlements: ReadonlyArray<{
          readonly contentKey: string | null;
          readonly iconUrl: string | null;
          readonly longDescription: string | null;
          readonly name: string;
          readonly quantity: string | null;
          readonly shortDescription: string | null;
          readonly sortOrder: number | null;
        }> | null;
        readonly group: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly planDetails: {
          readonly categoryIdentifiers: ReadonlyArray<string> | null;
          readonly contentKey: string | null;
          readonly description: string | null;
          readonly isTeamUpEligible: boolean | null;
          readonly planId: string;
          readonly planName: string;
          readonly productType: string | null;
        };
        readonly planImages: ReadonlyArray<{
          readonly defaultUrl: string | null;
          readonly description: string | null;
          readonly sortOrder: number | null;
          readonly standardUrl: string | null;
          readonly thumbnailUrl: string | null;
          readonly tinyUrl: string | null;
          readonly type: ImageType | null;
          readonly zoomUrl: string | null;
        }> | null;
        readonly price: {
          readonly basePrice: number | null;
          readonly basePriceExcludingTax: number | null;
          readonly priceFrequency: number | null;
          readonly pricePeriod: string | null;
          readonly priceType: string;
        };
        readonly productCharacteristics: {
          readonly balanceManagement: ProductBalanceManagementType | null;
          readonly offerEligibilityLevel: OfferEligibilityLevelType | null;
          readonly relatedOfferId: string | null;
          readonly relatedOfferIds: ReadonlyArray<string> | null;
        } | null;
        readonly promotions: ReadonlyArray<{
          readonly contentKey: string | null;
          readonly iconUrl: string | null;
          readonly longDescription: string | null;
          readonly name: string;
          readonly productType: ProductType;
          readonly shortDescription: string | null;
          readonly sortOrder: number | null;
        }> | null;
      }>;
      readonly promotions: ReadonlyArray<{
        readonly infoUrl: string | null;
        readonly longDescription: string | null;
        readonly name: string;
        readonly productType: ProductType;
      }>;
    };
    readonly code: number;
    readonly message: string;
  };
};
export type MobilePlanCardsProductsQuery = {
  response: MobilePlanCardsProductsQuery$data;
  variables: MobilePlanCardsProductsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channel"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeCompanions"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longDescription",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKey",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryId",
        "variableName": "categoryId"
      },
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      },
      {
        "kind": "Variable",
        "name": "includeCompanions",
        "variableName": "includeCompanions"
      }
    ],
    "concreteType": "EligibleProductOffersByCategoryResponse",
    "kind": "LinkedField",
    "name": "eligibleProductOffersByCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryDetail",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "promotions",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "infoUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductDetailsPlan",
            "kind": "LinkedField",
            "name": "plans",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductDetailsPlanDetail",
                "kind": "LinkedField",
                "name": "planDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planId",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planName",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTeamUpEligible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryIdentifiers",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductDetailsPlanPrice",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pricePeriod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceFrequency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "basePriceExcludingTax",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContractTerm",
                "kind": "LinkedField",
                "name": "contractTerm",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Entitlement",
                "kind": "LinkedField",
                "name": "entitlements",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "quantity",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "planImages",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zoomUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "standardUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tinyUrl",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "group",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Promotion",
                "kind": "LinkedField",
                "name": "promotions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCharacteristic",
                "kind": "LinkedField",
                "name": "productCharacteristics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balanceManagement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerEligibilityLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relatedOfferId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relatedOfferIds",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CtaOverride",
                "kind": "LinkedField",
                "name": "ctaOverrides",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "segment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "data",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "style",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dataLayerCategory",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MobilePlanCardsProductsQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MobilePlanCardsProductsQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "44c3030ff4de5ba6dd39eade2711f75f",
    "id": null,
    "metadata": {},
    "name": "MobilePlanCardsProductsQuery",
    "operationKind": "query",
    "text": "query MobilePlanCardsProductsQuery(\n  $categoryId: String!\n  $channel: String!\n  $includeCompanions: Boolean\n) {\n  eligibleProductOffersByCategory(categoryId: $categoryId, channel: $channel, includeCompanions: $includeCompanions) {\n    code\n    message\n    category {\n      id\n      name\n      description\n      promotions {\n        name\n        longDescription\n        productType\n        infoUrl\n      }\n      plans {\n        planDetails {\n          planId\n          description\n          planName\n          contentKey\n          isTeamUpEligible\n          categoryIdentifiers\n          productType\n        }\n        price {\n          priceType\n          pricePeriod\n          priceFrequency\n          basePrice\n          basePriceExcludingTax\n        }\n        contractTerm {\n          name\n        }\n        entitlements {\n          name\n          shortDescription\n          longDescription\n          quantity\n          iconUrl\n          sortOrder\n          contentKey\n        }\n        planImages {\n          description\n          sortOrder\n          defaultUrl\n          zoomUrl\n          standardUrl\n          thumbnailUrl\n          tinyUrl\n          type\n        }\n        group {\n          id\n          name\n        }\n        promotions {\n          name\n          shortDescription\n          longDescription\n          productType\n          sortOrder\n          contentKey\n          iconUrl\n        }\n        productCharacteristics {\n          balanceManagement\n          offerEligibilityLevel\n          relatedOfferId\n          relatedOfferIds\n        }\n        ctaOverrides {\n          type\n          label\n          segment\n          data\n          sortOrder\n          style\n        }\n        dataLayerCategory\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9be6cff1d19ac9e43a9c7a89726c5a0e";

export default node;
